import PaginationComponent from "components/pagination/Pagination";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import pendingReq from "../../../../../assets/img/icons/customIcons/filter.svg";
import { Row, Col } from "reactstrap";
import CompanyAllRequestcard from "./CompanyAllRequestcard";
import { getAllBookingRequestInfo } from "redux/actions/admin/AllBookingRequestAction";
import history from "helpers/History";
import SearchIcon from "../../../../../assets/img/icons/customIcons/searchicondark.svg";
import CustomFilter from "components/customFilter";

function CompanyAllRequestList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  setSearchFormData,
  data,
  handleClearDate,
  list,
  toggle,
  handleSearchOnSelect,
  empId,
  clearEmpId,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableHeight, setTableHeigth] = useState(300);

  const [empIdChip, setEmpIdChip] = useState(false);
  const allCompnayRequestList = useSelector(
    (state) => state.AllBookingReducer.result
  );
  const allCompnayRequestListLoader = useSelector(
    (state) => state.AllBookingReducer.loader
  );
  const notification = useSelector((state) => state.NotificationReducer.result);

  useEffect(
    () => {
      console.log("diffpageInbnd ", empId);
      setTitle(data);
      if (empId) {
        setEmpIdChip(true);
      } else if (notification?.empId) {
        setEmpIdChip(true);
      } else setEmpIdChip(false);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, notification]
  );

  // const clearDate = () => {
  //   const data = { ...searchFormData, fromDate: null, toDate: null };
  //   setSearchFormData(data);
  //   dispatch(getAllBookingRequestInfo("0", "1", data, ""));
  // };

  const clearChip = () => {
    setEmpIdChip(false);
    dispatch(getAllBookingRequestInfo("0", "1", null, ""));
    clearEmpId();
    history.push("/admin/booking-requests");
    dispatch({
      type: "NOTIFICATION_RESET",
    });
  };
  const handlePagination = (tab) => {
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(getAllBookingRequestInfo("0", "1", finalData, null));
  };
  // eslint-disable-next-line
  useEffect(() => {
    const divElement = document.getElementById("tableDiv");
    if (allCompnayRequestList?.pages?.length > 1) {
      setTableHeigth(divElement.scrollHeight - 72 + "px");
    } else {
      setTableHeigth(divElement.scrollHeight - 12 + "px");
    }
  });
  return (
    <div className="d-flex">
      <Col id="tableDiv" md={isFilter ? "9" : "12"}>
        <Row className="mb-2 second-search">
          <Col md="10 ">
            <div className="d-flex" style={{ alignItems: "center" }}>
              <h3 className="tab-title">
                {`${title} (${
                  allCompnayRequestList?.itemCount
                    ? allCompnayRequestList?.itemCount
                    : "0"
                })`}{" "}
              </h3>
              {empIdChip && (
                <div class="chip ml-3">
                  {empId || notification?.empId}
                  <span onClick={clearChip} class="closebtn">
                    &times;
                  </span>
                </div>
              )}
            </div>
          </Col>

          <Col md="2" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="common-outer-filter">
              {list && (
                <div className="btn-group new-cutom-filter  ">
                  <button
                    type="button"
                    onClick={() => {
                      setShowToggle(!showToggle);
                    }}
                    className={"btn dropdown-toggle mr-3"}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img alt="" src={pendingReq} width={"18px"} />
                  </button>
                  <div className="dropdown-menu dropdown-menu-right py-0">
                    {list?.map((item, key) => (
                      <button
                        key={key}
                        className="dropdown-item"
                        onClick={() => toggle(item?.tabId)}
                        type="button"
                        style={{
                          backgroundColor:
                            item?.tabId === "0" ? "#5e72e4" : "none",
                          color: item?.tabId === "0" ? "white" : "none",
                        }}
                      >
                        {item?.title}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="common-outer-filter">
              <div className="btn-group new-cutom-filter ">
                <button
                  type="button"
                  onClick={() => setIsFilter(!isFilter)}
                  className={"btn dropdown-toggle mr-3"}
                >
                  <img alt="" src={SearchIcon} width={"18px"} />
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <CompanyAllRequestcard loader={allCompnayRequestListLoader} />

        <div
          style={{
            display: allCompnayRequestListLoader ? "none" : "contents",
          }}
        >
          <PaginationComponent
            totalCount={allCompnayRequestList?.itemCount}
            handlePagination={handlePagination}
            activePage={allCompnayRequestList?.activePage}
          />
        </div>
      </Col>
      {/* {isFilter && ( */}
        <Col
          md="3"
          style={{
            height: tableHeight,
            minHeight: "670px",
            display: isFilter ? "block" : "none",
          }}
        >
          <CustomFilter
            tableHeight={tableHeight}
            minHeight={"670px"}
            handleSearchOnSelect={handleSearchOnSelect}
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleEmployeeSearchOnChange}
            type="inbound"
            list={list}
            isFilter={isFilter}
            setIsFilter={setIsFilter}
            handleClearDate={handleClearDate}
          />
        </Col>
      {/* )} */}
    </div>
  );
}

export default CompanyAllRequestList;
